import { computed, get } from '@ember/object';
import { filter } from '@ember/object/computed';
import { isEmpty, isPresent } from '@ember/utils';
import Component from '@glimmer/component';

/*
  attrs
    - contact
    - model - array of tasks
*/

export default class TasksComponent extends Component {
  // Sort ascending but have tasks without due dates at the end.
  @computed('args.model.@each.dueAt')
  get sortedTasks() {
    return this.args.model.toArray().sort((a, b) => {
      const aVal = a.dueAt;
      const bVal = b.dueAt;
      let returnVal = 0;
      if (bVal == null) {
        returnVal = -1;
      } else if (aVal == null || aVal > bVal) {
        returnVal = 1;
      } else if (bVal == null || aVal < bVal) {
        returnVal = -1;
      }
      return returnVal;
    });
  }

  @filter('sortedTasks', function (task) {
    return isEmpty(task.completedAt);
  })
  unfinishedTasks;

  @filter('sortedTasks', function (task) {
    return isPresent(task.completedAt);
  })
  finishedTasks;
}
